import {
  Component, EventEmitter, Input,
  OnInit, Output,
} from '@angular/core';
import {CountryService} from "@cybfed/core/services/countries.service";
import {DropdownComponent} from "@cybfed/ui-lib/dropdown/dropdown.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {NgClass, NgStyle} from "@angular/common";

// src/app/fonts.enum.ts
export enum Fonts {
  StalinistOne = 'Stalinist One',
  Ruda = 'Ruda',
  Pangolin = 'Pangolin',
  Cuprum = 'Cuprum',
  ElMessiri = 'El Messiri',
  TenorSans = 'Tenor Sans',
  Arsenal = 'Arsenal',
  ProstoOne = 'Prosto One',
  Scada = 'Scada',
  Jura = 'Jura',
  UbuntuMono = 'Ubuntu Mono',
  Montserrat = 'Montserrat',
  RubikMonoOne = 'Rubik Mono One',
  AmaticSC = 'Amatic SC',
  CormorantUnicase = 'Cormorant Unicase',
  Marmelad = 'Marmelad',
  Gabriela = 'Gabriela',
  Andika = 'Andika',
  Pattaya = 'Pattaya',
  YesevaOne = 'Yeseva One',
  Kurale = 'Kurale',
  Underdog = 'Underdog',
  Oswald = 'Oswald',
  CormorantSC = 'Cormorant SC',
  Exo2 = 'Exo 2',
  Rubik = 'Rubik',
  SpectralSC = 'Spectral SC',
  PTSansCaption = 'PT Sans Caption',
  Lora = 'Lora',
  Merriweather = 'Merriweather',
  PlayfairDiMerriweather = 'Playfair Di Merriweather',
  NotoSerif = 'Noto Serif',
  RussoOne = 'Russo One',
  Philosopher = 'Philosopher',
  DidactGothic = 'Didact Gothic',
  Neucha = 'Neucha',
  BadScript = 'Bad Script',
  RobotoSlab = 'Roboto Slab',
  PoiretOne = 'Poiret One',
  MarckScript = 'Marck Script',
  Play = 'Play',
  Comfortaa = 'Comfortaa',
  KellySlab = 'Kelly Slab',
  RuslanDisplay = 'Ruslan Display',
  RobotoCondensed = 'Roboto Condensed',
  Arial = 'Arial',
  TimesNewRoman = 'Times New Roman',
  CourierNew = 'Courier New',
  OpenSans = 'Open Sans',
  OpenSansCondensed = 'Open Sans Condensed',
  Lobster = 'Lobster',
  PressStart2P = 'Press Start 2P',
  VT323 = 'VT323',
  Orbitron = 'Orbitron',
  Audiowide = 'Audiowide',
  Bungee = 'Bungee',
  Bangers = 'Bangers'
}



@Component({
  selector: 'app-font-selectbox',
  templateUrl: './font-selectbox.component.html',
  standalone: true,
  imports: [
    DropdownComponent,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    NgClass,
    NgStyle
  ],
  providers: [
    CountryService
  ],
  styleUrls: ['./font-selectbox.component.scss']
})
export class FontSelectboxComponent implements OnInit {
  fonts = Object.values(Fonts);
  searchText: string = '';  // property bound to the search input
  @Output() onSelectFont: EventEmitter<any> = new EventEmitter<any>();
  @Input() seatedItem: any  = this.fonts[0];

  constructor() { }

  ngOnInit(): void { }

  // Getter to filter fonts based on searchText
  get filteredFonts() {
    if (!this.searchText) {
      return this.fonts;
    }
    return this.fonts.filter(font =>
        font.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  // Handler for font selection
  onFontChange(item: any) {
    this.seatedItem = item;
    this.onSelectFont.emit(item);
    // Optionally clear search after selection:
    this.searchText = '';
  }

  stopPropogation($event: any){
    $event.preventDefault();
    $event.stopPropagation();
    return false;
  }


}
